
import { Shield, Rocket, CircuitBoard, Terminal, Database, Star, Zap, Globe, Smartphone, Code2, Monitor, Brain, Layers } from "lucide-react";
import { Helmet } from "react-helmet-async";
import ClientsSection from "@/components/ClientsSection";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import TechnologiesSection from "@/components/TechnologiesSection";


const services = [
  { 
    title: 'Desenvolvimento Web', 
    description: 'Sites, e-commerces e aplicações web modernas com tecnologias avançadas.',
    icon: Globe
  },
  { 
    title: 'Aplicativos Mobile', 
    description: 'Apps nativos e híbridos para iOS e Android com performance excepcional.',
    icon: Smartphone
  },
  { 
    title: 'Sistemas ERP/CRM', 
    description: 'Gestão completa de negócios com integrações personalizadas.',
    icon: Database
  },
  { 
    title: 'Jogos Digitais', 
    description: 'Desenvolvimento de jogos 2D e 3D para múltiplas plataformas.',
    icon: CircuitBoard
  },
  { 
    title: 'Cibersegurança', 
    description: 'Pentests, ethical hacking e proteção avançada de dados.',
    icon: Shield
  },
  { 
    title: 'Automação e Scripts', 
    description: 'Bots e automações inteligentes para otimizar processos.',
    icon: Terminal
  },
];

const stats = [
  { value: '500+', label: 'Projetos Entregues', icon: Rocket },
  { value: '98%', label: 'Satisfação Cliente', icon: Star },
  { value: '100+', label: 'Empresas Atendidas', icon: Shield },
];

const technologies = [
  { name: 'React', icon: Code2 },
  { name: 'Node.js', icon: Terminal },
  { name: 'Python', icon: Database },
  { name: 'AWS', icon: Globe },
  { name: 'React Native', icon: Smartphone },
  { name: 'TypeScript', icon: CircuitBoard },
  { name: 'Docker', icon: Layers },
  { name: 'AI/ML', icon: Brain },
  { name: 'Next.js', icon: Monitor },
  { name: 'GraphQL', icon: Zap },
  { name: 'PostgreSQL', icon: Database },
  { name: 'Kubernetes', icon: Layers },
];

export default function Index() {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Início — AlphaLabs</title>
        <meta name="description" content="Transforme seu negócio com soluções inovadoras em desenvolvimento, ERP/CRM e cibersegurança da AlphaLabs." />
      </Helmet>
      
      {/* Hero Section - Blue Background */}
      <HeroSection />

      {/* Services Section - White Background */}
      <ServicesSection />

      {/* Technologies Section - White Background */}
      <TechnologiesSection />

      {/* Clients Section - White Background */}
      <ClientsSection />
    </div>
  );
}